import React, { useEffect, useState } from "react";
import GeneralDistributerModal from "../../components/distributerMaster/GeneralDistributerModal";
import "../distributerMaster/distributerMaster.scss";
import useForm from "./useForm";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import FetchData from "../../providers/dataProvider";
import CreditLimitRequestModal from "../../components/distributerMaster/CreditLimitRequestModal";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../components/common/ErrorMessage";

const AddNewDistributer = () => {
  const {
    HandleFormChange,
    HandleSubmit,
    handleSelectChange,
    values,
    errors,
    HandleFileChange,
    handleDocumentChange,
    handleDeleteFile,
    handleAttachmentDate,
    removeAttachedFile,
    setValues,
    setErrors,
    createMsg,
    show,
    setShow,
    setCreateMsg,
    country,
    currency,
    designation,
    type,
    company,
    setCompany,
    setCountry,
    setType,
    setDesignation,
    setCurrency,
    handleCountryChange,
    handleTypeChange,
    handleCurrencyChange,
    handleDesignationChange,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    docError,
    setDocError,
    loading,
    handleStatusChange,
    authPerson,
    setAuthPerson,
    assignedEngineer,
    setAssignedEngineer
  } = useForm();

  const { data: countryList } = FetchData("country");
  const { data: distributorTypeList } = FetchData("distributorType");
  const { data: currencyList } = FetchData("currency");
  const { data: companyList } = FetchData("company");
  const navigate = useNavigate();

  const handleRedirect = () => {
    setValues({});
    navigate("/distributor-master");
  };

      useEffect(() => {
      window.dispatchEvent(
        new CustomEvent("pathfinderHeaderMetaChange", {
          detail: {
            pathname: location.pathname,
            title: values?.id
              ? `Distributor : ${values?.distributorName}`
              : "New Distributor",
            backTarget: {
              pathname: "/distributor-master",
            },
          },
        })
      );
    
      return () => {
        window.dispatchEvent(
          new CustomEvent("pathfinderHeaderMetaChange", {
            detail: {
              pathname: location.pathname,
              clear: true,
            },
          })
        );
      };
    }, [
      location.pathname,
      values?.id,
      values?.distributorName,
    ]);

  return (
    <div className="container-fluid add-new-distributer-sec">
      <section className="distributer-add-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {/*<!--General Distributer-->*/}
            <GeneralDistributerModal
              HandleFormChange={HandleFormChange}
              handleSelectChange={handleSelectChange}
              errors={errors}
              values={values}
              HandleFileChange={HandleFileChange}
              handleDocumentChange={handleDocumentChange}
              setValues={setValues}
              setErrors={setErrors}
              HandleSubmit={HandleSubmit}
              countryList={countryList}
              distributorTypeList={distributorTypeList}
              currencyList={currencyList}
              companyList={companyList}
              removeAttachedFile={removeAttachedFile}
              handleDeleteFile={handleDeleteFile}
              handleAttachmentDate={handleAttachmentDate}
              country={country}
              currency={currency}
              company={company}
              type={type}
              designation={designation}
              setCompany={setCompany}
              setCountry={setCountry}
              setCurrency={setCurrency}
              setType={setType}
              setDesignation={setDesignation}
              handleCountryChange={handleCountryChange}
              handleTypeChange={handleTypeChange}
              handleCurrencyChange={handleCurrencyChange}
              handleDesignationChange={handleDesignationChange}
              handleRedirect={handleRedirect}
              docError={docError}
              setDocError={setDocError}
              loading={loading}
              handleStatusChange={handleStatusChange}
              authPerson={authPerson}
              setAuthPerson={setAuthPerson}
              assignedEngineer={assignedEngineer}
              setAssignedEngineer={setAssignedEngineer}
            />
          </div>
        </div>
      </section>

      {/* <!-- saveSuccessModal --> */}
      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
      <CreditLimitRequestModal />
    </div>
  );
};

export default AddNewDistributer;
